import { render } from "./CurrencyFormatter.vue?vue&type=template&id=4e425773&scoped=true"
import script from "./CurrencyFormatter.vue?vue&type=script&lang=js"
export * from "./CurrencyFormatter.vue?vue&type=script&lang=js"

import "./CurrencyFormatter.vue?vue&type=style&index=0&id=4e425773&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e425773"]])

export default __exports__